import { z } from 'zod'
import { baseSchema } from './base'

export const divSchema = baseSchema.extend({
  type: z.literal('div'),
  body: z.any().array().optional().describe('子元素'),
  style: z.record(z.string(), z.any()).optional().describe('样式'),
})

export type DivSchema = z.infer<typeof divSchema>
